import PropTypes from "prop-types"
import { Paper } from "@mui/material"
import { isEmpty } from "lodash"
import { DOWNLOAD_FILENAME, TABLE_DOWNLOAD_DATA } from "helpers/shapes/compare-screen"
import CompareTopicSummaryTables from "./components/compare-topic-summary-tables"
import "./style.scss"

export default function CompareTopicSummary({
  items,
  detailsItems,
  detailsData,
  groups,
  selectedGroup,
  fixedItemNumber,
  smartTradeRiskData,
  instrumentPortfolio,
  maxNbColumns,
  setGroup,
  saveGroupToStore,
  fileName,
  tableDownloadData,
}) {
  return <Paper className="modules_compare-topic-summary" elevation={1}>
    <div className="wrapper">
      <CompareTopicSummaryTables
        {...{ items: detailsItems,
          data: detailsData,
          columns: items,
          groups,
          setGroup,
          saveGroupToStore,
          storeName: "topicSummary",
          selectedGroup,
          fixedItemNumber,
          smartTradeRiskData,
          isPortfolio: !isEmpty(instrumentPortfolio),
          maxNbColumns,
          fileName,
          tableDownloadData,
        }}
      />
    </div>
  </Paper>
}

CompareTopicSummary.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    noData: PropTypes.bool,
    isUnmodeled: PropTypes.bool,
  })).isRequired,
  detailsItems: PropTypes.object.isRequired,
  detailsData: PropTypes.array.isRequired,
  smartTradeRiskData: PropTypes.object,
  setGroup: PropTypes.func.isRequired,
  saveGroupToStore: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object.isRequired,
  groups: PropTypes.array.isRequired,
  fixedItemNumber: PropTypes.bool,
  instrumentPortfolio: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  maxNbColumns: PropTypes.number,
  fileName: DOWNLOAD_FILENAME,
  tableDownloadData: TABLE_DOWNLOAD_DATA,
}
